<template>
  <div>
    <div
      v-if="!doctorGroups.length"
      class="pb-8"
    >
      <ResultsPlaceholder
        data-qa="list-placeholder"
        src="/graphics/cross.svg"
        title="Здесь нет победителей"
        text="В регионе не хватило участников для составления рейтинга"
        :button-text="`Положение о Премии ${year}`"
        @click:button="onOpenRulesClick"
      />
    </div>
    <template v-else>
      <v-container>
        <PersistentAutocomplete
          label="Специальность"
          :items="specialities"
          @search="debouncedSearch"
          @input="onSelect"
        />

        <div
          v-if="!searchedSpecialities.length"
          class="pt-5 mt-15"
        >
          <ResultsPlaceholder
            data-qa="list-placeholder"
            src="/graphics/lense.svg"
            title="Ничего не нашлось"
            text="Эта специальность не участвовала в премии"
          />
        </div>

        <div
          v-else
          class="mt-6"
        >
          <DoctorsList
            :groups="searchedSpecialities"
            @item:click="selectDoctor"
          />
        </div>
      </v-container>

      <BaseDialog
        width="456"
        :title="`Премия ПроДокторов ${year}`"
        :is-active="isDialogVisible"
        @click:close="unselectDoctor"
        @keydown.esc="unselectDoctor"
      >
        <DoctorInfoItem
          v-if="selectedDoctor"
          :key="selectedDoctor.id + 'modal'"
          :doctor="selectedDoctor"
          @click:copy="copyUrl"
        />
      </BaseDialog>
    </template>
  </div>
</template>

<script setup lang="ts">
import type { PropType } from 'vue'
import type { IDoctorGroup } from '~/types'
import DoctorInfoItem from '~/features/doctors/components/DoctorInfoItem.vue'

const props = defineProps({
  doctorGroups: { type: Array as PropType<IDoctorGroup[]>, required: true },
  year: { type: Number, required: true },
})

const refProps = toRefs(props)

const {
  selectedDoctor,
  isDialogVisible,
  specialities,
  searchedSpecialities,
  onOpenRulesClick,
  unselectDoctor,
  selectDoctor,
  copyUrl,
  onSelect,
  debouncedSearch,
} = useDoctors(refProps.doctorGroups, refProps.year)
</script>
